
import DataImport from "@common/src/components/scope/data-import/index.vue";
import { Component, Vue } from "vue-property-decorator";
import { Table } from "@common/src/utils/decorator";
@Component({
  components: { DataImport }
})
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/speedbiz/template/2.8/入库单快速导入.xlsx",
  actionUrl: "/filecloud/importFastInbounds"
})
export default class ImportPartsInbound extends Vue {}
